import { t as isTouchDevice } from "./utilities-2Suih3Nm.js";
(() => {
  let contentEl = null;
  let currentTrigger = null;
  let timer = null;
  const activeStates = /* @__PURE__ */ new WeakMap();
  const updatePosition = (trigger) => {
    if (!contentEl || !trigger) return;
    const triggerRect = trigger.getBoundingClientRect();
    const contentRect = contentEl.getBoundingClientRect();
    const scrollX = window.scrollX || window.pageXOffset;
    const scrollY = window.scrollY || window.pageYOffset;
    const gap = 8;
    const position = (trigger.getAttribute("data-tooltip-position") || "top").toLowerCase();
    let x = 0;
    let y = 0;
    switch (position) {
      case "bottom":
        x = triggerRect.left + scrollX + triggerRect.width / 2 - contentRect.width / 2;
        y = triggerRect.top + scrollY + triggerRect.height + gap;
        break;
      case "left":
        x = triggerRect.left + scrollX - contentRect.width - gap;
        y = triggerRect.top + scrollY + triggerRect.height / 2 - contentRect.height / 2;
        break;
      case "right":
        x = triggerRect.left + scrollX + triggerRect.width + gap;
        y = triggerRect.top + scrollY + triggerRect.height / 2 - contentRect.height / 2;
        break;
      case "top":
      default:
        x = triggerRect.left + scrollX + triggerRect.width / 2 - contentRect.width / 2;
        y = triggerRect.top + scrollY - contentRect.height - gap;
        break;
    }
    contentEl.dataset.tooltipPosition = position;
    contentEl.style.transform = `translate(${x}px, ${y}px)`;
  };
  const createTooltip = (trigger) => {
    const content = trigger.getAttribute("data-tooltip");
    const contentActive = trigger.getAttribute("data-tooltip-active");
    const isActive = activeStates.get(trigger);
    if (contentEl) contentEl.remove();
    contentEl = document.createElement("div");
    contentEl.classList.add("tooltip-content");
    contentEl.innerHTML = isActive && contentActive ? contentActive : content;
    document.body.appendChild(contentEl);
    currentTrigger = trigger;
    updatePosition(trigger);
    requestAnimationFrame(() => {
      if (contentEl) contentEl.style.opacity = "1";
    });
  };
  const removeTooltip = () => {
    if (!contentEl) return;
    const el = contentEl;
    contentEl = null;
    currentTrigger = null;
    el.style.opacity = "0";
    setTimeout(() => el.remove(), 300);
  };
  document.addEventListener("mouseenter", (e) => {
    if (isTouchDevice()) return;
    if (e.target && e.target.hasAttribute && e.target.hasAttribute("data-tooltip")) {
      createTooltip(e.target);
    }
  }, true);
  document.addEventListener("focusin", (e) => {
    if (isTouchDevice()) return;
    if (e.target && e.target.hasAttribute && e.target.hasAttribute("data-tooltip")) {
      createTooltip(e.target);
    }
  }, true);
  document.addEventListener("mouseleave", (e) => {
    if (isTouchDevice()) return;
    if (e.target && e.target.hasAttribute && e.target.hasAttribute("data-tooltip") && e.target === currentTrigger) {
      removeTooltip();
    }
  }, true);
  document.addEventListener("focusout", (e) => {
    if (isTouchDevice()) return;
    if (e.target && e.target.hasAttribute && e.target.hasAttribute("data-tooltip") && e.target === currentTrigger) {
      removeTooltip();
    }
  }, true);
  document.addEventListener("click", (e) => {
    if (!e.target.closest("[data-tooltip]")) return;
    if (isTouchDevice()) return;
    const trigger = e.target.closest("[data-tooltip]");
    const contentActive = trigger.getAttribute("data-tooltip-active");
    if (!contentActive) return;
    activeStates.set(trigger, true);
    if (contentEl && currentTrigger === trigger) {
      contentEl.innerHTML = contentActive;
      updatePosition(trigger);
    }
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      activeStates.set(trigger, false);
      const content = trigger.getAttribute("data-tooltip");
      if (contentEl && currentTrigger === trigger) {
        contentEl.innerHTML = content;
        updatePosition(trigger);
      }
    }, 2e3);
  });
})();
